import { api } from "@/lib/api/client";
import {
  LoginResponseSchema,
  RefreshResponseSchema,
  type LoginResponse,
  type LoginRequest,
  type RefreshResponse,
  type AuthUser,
} from "@pkhoffice/shared";

export async function login(req: LoginRequest): Promise<LoginResponse> {
  const { data } = await api.post("/auth/login", req);
  const payload = data.data ?? data;
  return LoginResponseSchema.parse(payload);
}

export async function refresh(refreshToken: string): Promise<RefreshResponse> {
  const { data } = await api.post("/auth/refresh", { refreshToken });
  const payload = data.data ?? data;
  return RefreshResponseSchema.parse(payload);
}

export async function logout(): Promise<void> {
  try {
    await api.post("/auth/logout");
  } catch {
    // ignore — client clear is authoritative
  }
}

export async function fetchMe(): Promise<AuthUser> {
  const { data } = await api.get("/user/me");
  const payload = data.data ?? data;
  return payload as AuthUser;
}
